import React, { useRef, useEffect, useState } from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";

interface TruncatedToolTipChildrenProps {
  children: React.ReactNode;
  className?: string;
  width?: string | number;
}

const TruncatedToolTipChildren: React.FC<TruncatedToolTipChildrenProps> = ({ children, className = "", width }) => {
  const spanRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const checkTruncation = () => {
      if (spanRef.current) {
        const isOverflowing = spanRef.current.scrollWidth > spanRef.current.clientWidth;
        setIsTruncated(isOverflowing);
      }
    };

    checkTruncation();
    const resizeObserver = new ResizeObserver(checkTruncation);
    if (spanRef.current) {
      resizeObserver.observe(spanRef.current);
    }
    return () => {
      resizeObserver.disconnect();
    };
  }, [children, width]);

  const style = {
    display: "inline-block" as const,
    overflow: "hidden" as const,
    whiteSpace: "nowrap" as const,
    textOverflow: "ellipsis" as const,
    verticalAlign: "bottom" as const,
    width: width || "100%",
    maxWidth: width || "100%",
  };

  const spanElement = (
    <span ref={spanRef} className={className} style={style}>
      {children}
    </span>
  );

  return isTruncated ? (
    <Tippy content={<span>{children}</span>} animation="fade" theme="light">
      {spanElement}
    </Tippy>
  ) : (
    spanElement
  );
};

export default TruncatedToolTipChildren;
